import classNames from 'classnames';
import { useCallback } from 'react';
import { InputNumber, InputNumberProps } from 'antd';
import { toEnNumber } from '@/utils';

function parseLocalizedNumber(value: string | undefined): number | string {
  if (value == null || value === '') return '';
  const normalized = toEnNumber(String(value)).replace(/[^\d]/g, '');
  if (normalized === '') return '';
  return Number(normalized);
}

export function InputNumeric({
  className,
  onKeyDown,
  onPaste,
  parser,
  ...rest
}: InputNumberProps) {

  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!event.ctrlKey && !event.altKey && !event.metaKey && !event.shiftKey) {
      if (event.key.length === 1 && !/[0-9۰-۹٠-٩]/.test(event.key)) {
        event.preventDefault();
      }
    }
    onKeyDown && onKeyDown(event);
  }, [onKeyDown]);

  const handlePaste = useCallback((e: React.ClipboardEvent<HTMLInputElement>) => {
    const text = toEnNumber(e.clipboardData.getData('text/plain'));
    if (!/^\d+$/.test(text)) {
      e.preventDefault();
      return;
    }
    onPaste && onPaste(e);
  }, [onPaste]);

  const handleParser = useCallback((displayValue: string | undefined) => {
    if (parser) {
      return parser(displayValue);
    }
    return parseLocalizedNumber(displayValue);
  }, [parser]);

  return (
    <InputNumber
      controls={false}
      onPaste={handlePaste}
      onKeyDown={handleKeyDown}
      parser={handleParser}
      className={classNames('w-full', className)}
      {...rest}
    />
  );
}

export default InputNumeric;
